/* eslint-disable prettier/prettier */
import React from 'react';
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  Button,
  Box,
  Text,
  Flex,
  Input,
} from '@chakra-ui/react';
import { Calendar } from 'lucide-react';

interface CustomDateRangePickerProps {
  isActive: boolean;
  dateStart: string;
  dateEnd: string;
  // eslint-disable-next-line no-unused-vars
  onDateStartChange: (date: string) => void;
  // eslint-disable-next-line no-unused-vars
  onDateEndChange: (date: string) => void;
  onApply: () => void;
}

export function CustomDateRangePicker({
  isActive,
  dateStart,
  dateEnd,
  onDateStartChange,
  onDateEndChange,
  onApply,
}: CustomDateRangePickerProps) {
  return (
    <Popover>
      <PopoverTrigger>
        <Button
          variant={isActive ? 'solid' : 'outline'}
          colorScheme={isActive ? 'blue' : 'gray'}
          size="sm"
          leftIcon={<Calendar size={16} />}
        >
          Periodo Personalizado
        </Button>
      </PopoverTrigger>
      <PopoverContent w="320px">
        <PopoverBody p={4}>
          <Text fontWeight="semibold" mb={3}>
            Selecione o periodo
          </Text>
          <Flex direction="column" gap={3}>
            <Box>
              <Text fontSize="sm" mb={1}>
                Data Inicial
              </Text>
              <Input
                type="date"
                value={dateStart}
                onChange={e => onDateStartChange(e.target.value)}
                size="sm"
              />
            </Box>
            <Box>
              <Text fontSize="sm" mb={1}>
                Data Final
              </Text>
              <Input
                type="date"
                value={dateEnd}
                onChange={e => onDateEndChange(e.target.value)}
                size="sm"
              />
            </Box>
            <Button
              colorScheme="blue"
              size="sm"
              onClick={onApply}
              isDisabled={!dateStart || !dateEnd}
            >
              Aplicar
            </Button>
          </Flex>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
}
